<template>
  <v-dialog v-model="show" persistent max-width="700" transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Pacientes Adicionales</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pt-4">
        <v-chip label color="primary" outlined class="mb-4">
          <v-icon left>mdi-account</v-icon>
          Paciente principal: {{ pacientePrincipal }}
        </v-chip>

        <v-progress-linear
          v-if="loading"
          indeterminate
          color="primary"
          class="mb-4"
        ></v-progress-linear>

        <v-alert
          v-if="!loading && listaPacientesAdicionales.length === 0"
          color="purple"
          dark
          outlined
        >
          No hay pacientes adicionales asignados
        </v-alert>

        <v-simple-table v-if="!loading && listaPacientesAdicionales.length > 0">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Nombre Completo</th>
                <th class="text-left">DNI</th>
                <th class="text-left">Fecha Asociación</th>
                <th class="text-left">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="paciente in listaPacientesAdicionales" :key="paciente.id">
                <td>{{ paciente.nombreCompleto }}</td>
                <td>{{ paciente.dni }}</td>
                <td>{{ formatFecha(paciente.fechaAsociacion) }}</td>
                <td>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        color="red"
                        v-on="on"
                        v-bind="attrs"
                        @click="confirmarEliminar(paciente)"
                      >
                        mdi-delete
                      </v-icon>
                    </template>
                    <span>Eliminar paciente</span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click.stop="showBuscarPaciente = true">
          <v-icon left>mdi-account-plus</v-icon>
          Agregar Paciente
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="error" @click.stop="show = false">Cerrar</v-btn>
      </v-card-actions>
    </v-card>

    <BuscarPacienteTurno
      :visible="showBuscarPaciente"
      @close="showBuscarPaciente = false"
      @seleccionarPaciente="agregarPaciente"
    />
  </v-dialog>
</template>

<script>
import axios from "../../axios-auth.js";
import BuscarPacienteTurno from "./BuscarPacienteTurno.vue";

export default {
  components: {
    BuscarPacienteTurno,
  },

  data: () => ({
    listaPacientesAdicionales: [],
    loading: false,
    showBuscarPaciente: false,
  }),

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    idTurno: {
      type: Number,
      default: null,
    },
    pacientePrincipal: {
      type: String,
      default: "",
    },
  },

  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },

  watch: {
    visible(newVal) {
      if (newVal && this.idTurno) {
        this.cargarPacientesAdicionales();
      }
    },
  },

  methods: {
    cargarPacientesAdicionales() {
      this.loading = true;
      let self = this;
      axios
        .get("/Turnos/GetPacientesAdicionales", {
          params: {
            idTurno: this.idTurno,
          },
        })
        .then(function (response) {
          if (response.data != null) {
            self.listaPacientesAdicionales = response.data;
          } else {
            self.listaPacientesAdicionales = [];
          }
          self.loading = false;
        })
        .catch(function (error) {
          self.loading = false;
          self.$swal.fire({
            icon: "error",
            title: "Error al cargar pacientes adicionales",
            showConfirmButton: false,
            background: "#ececec",
            timer: 2000,
          });
        });
    },

    agregarPaciente(item) {
      this.showBuscarPaciente = false;
      let self = this;
      axios
        .post("/Turnos/AgregarPacienteAdicional", {
          idTurno: this.idTurno,
          idPaciente: item.idpaciente,
        })
        .then(function (response) {
          if (response.data === "ok") {
            self.cargarPacientesAdicionales();
            self.$emit("actualizado");
          } else {
            self.$swal.fire({
              icon: "error",
              title: response.data || "Error al agregar paciente",
              showConfirmButton: false,
              background: "#ececec",
              timer: 3000,
            });
          }
        })
        .catch(function (error) {
          self.$swal.fire({
            icon: "error",
            title: "Error al agregar paciente adicional",
            showConfirmButton: false,
            background: "#ececec",
            timer: 2000,
          });
        });
    },

    confirmarEliminar(paciente) {
      let self = this;
      this.$swal
        .fire({
          title: "¿Está seguro?",
          text: `Se eliminará a ${paciente.nombreCompleto} de los pacientes adicionales del turno.`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sí, eliminar",
          cancelButtonText: "Cancelar",
        })
        .then((result) => {
          if (result.isConfirmed) {
            self.eliminarPaciente(paciente.id);
          }
        });
    },

    eliminarPaciente(id) {
      let self = this;
      axios
        .get("/Turnos/EliminarPacienteAdicional", {
          params: {
            id: id,
          },
        })
        .then(function (response) {
          if (response.data === "ok") {
            self.cargarPacientesAdicionales();
            self.$emit("actualizado");
          } else {
            self.$swal.fire({
              icon: "error",
              title: response.data || "Error al eliminar paciente",
              showConfirmButton: false,
              background: "#ececec",
              timer: 3000,
            });
          }
        })
        .catch(function (error) {
          self.$swal.fire({
            icon: "error",
            title: "Error al eliminar paciente adicional",
            showConfirmButton: false,
            background: "#ececec",
            timer: 2000,
          });
        });
    },

    formatFecha(fecha) {
      if (!fecha) return "";
      const date = new Date(fecha);
      return date.toLocaleDateString("es-AR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },
  },
};
</script>
